import { render, staticRenderFns } from "./institutionPicker.vue?vue&type=template&id=ce485eb4&scoped=true"
import script from "./institutionPicker.vue?vue&type=script&lang=ts"
export * from "./institutionPicker.vue?vue&type=script&lang=ts"
import style0 from "@/components/institutions/institutionView/profileView/teacherPicker/teacherPicker.css?vue&type=style&index=0&id=ce485eb4&prod&scoped=true&lang=css&external"
import style1 from "./institutionPicker.css?vue&type=style&index=1&id=ce485eb4&prod&scoped=true&lang=css&external"
import style2 from "@/components/common/modern/modern.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@/components/acquisitionList/ui/acquisitionViews.css?vue&type=style&index=3&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce485eb4",
  null
  
)

export default component.exports